import { render } from "./AssignedUnitsPanel.vue?vue&type=template&id=7bd67e08"
import script from "./AssignedUnitsPanel.vue?vue&type=script&lang=js"
export * from "./AssignedUnitsPanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__